import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import businessData from '../data/businessdata.json';
import SafeIcon from '../common/SafeIcon';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: t('nav.services'), href: '#services' },
    { name: t('nav.about'), href: '#about' },
    { name: t('nav.testimonials'), href: '#testimonials' },
  ];

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group">
          <div className="bg-brand text-white p-2 rounded-lg group-hover:bg-brand-hover transition-colors">
            <SafeIcon name="Droplet" className="text-2xl" />
          </div>
          <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-gray-900' : 'text-gray-900 lg:text-gray-900'}`}>
            {businessData.name}
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-gray-700 hover:text-brand font-medium transition-colors">
              {link.name}
            </a>
          ))}
        </nav>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-4">
          <button 
            onClick={toggleLanguage}
            className="flex items-center gap-1 text-sm font-semibold text-gray-600 hover:text-brand transition-colors bg-gray-100 px-3 py-1.5 rounded-full"
          >
            <SafeIcon name="Globe" />
            {language.toUpperCase()}
          </button>
          
          <a 
            href={`tel:${businessData.phoneRaw}`}
            className="flex items-center gap-2 bg-brand hover:bg-brand-hover text-white px-5 py-2.5 rounded-full font-semibold transition-all shadow-sm hover:shadow-md"
          >
            <SafeIcon name="Phone" />
            <span className="hidden lg:inline">{businessData.phoneDisplay}</span>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-gray-700 text-2xl"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon name={mobileMenuOpen ? "X" : "Menu"} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-gray-100 py-4 flex flex-col px-4 gap-4">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              className="text-gray-800 font-medium py-2 border-b border-gray-50"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <div className="flex justify-between items-center pt-2">
            <button 
              onClick={toggleLanguage}
              className="flex items-center gap-1 text-sm font-semibold text-gray-600 bg-gray-100 px-4 py-2 rounded-full"
            >
              <SafeIcon name="Globe" />
              {language === 'en' ? 'Français' : 'English'}
            </button>
            <a 
              href={`tel:${businessData.phoneRaw}`}
              className="flex items-center gap-2 bg-brand text-white px-4 py-2 rounded-full font-semibold"
            >
              <SafeIcon name="Phone" /> Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;